/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosCoinTopLoserRequest = {
    type?: AptosCoinTopLoserRequest.type;
    size?: number;
};

export namespace AptosCoinTopLoserRequest {

    export enum type {
        ALL = 'ALL',
        MEME = 'MEME',
    }


}

